import { Outlet } from 'react-router-dom'
import { useTheme } from '../../hooks/useTheme'
import ErrorBoundary from '../shared/ErrorBoundary'
import Toasts from '../shared/Toasts'
import { InstallBanner } from '../shared/InstallBanner'
import { BottomNav } from '../nav/BottomNav'

export default function DashboardLayout() {
  useTheme()

  return (
    <div className="theme-background min-h-screen flex justify-center">
      <div className="relative w-full max-w-[480px] flex flex-col min-h-screen">

        <main className="flex-1 overflow-y-auto pb-28">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>

        <Toasts />
        <InstallBanner />
        <BottomNav />

      </div>
    </div>
  )
}
